import { SVGProps } from 'react';

// The face mark alone — x 0→30.68 of the wordmark's 97-wide viewBox.
const markPaths = (
  <>
    <path d="M11.2626 15.9992C12.9858 15.9992 14.3827 14.6023 14.3827 12.8791C14.3827 11.1559 12.9858 9.75904 11.2626 9.75904C9.53948 9.75904 8.14258 11.1559 8.14258 12.8791C8.14258 14.6023 9.53948 15.9992 11.2626 15.9992Z" />
    <path d="M19.4157 15.9992C21.1389 15.9992 22.5358 14.6023 22.5358 12.8791C22.5358 11.1559 21.1389 9.75904 19.4157 9.75904C17.6926 9.75904 16.2957 11.1559 16.2957 12.8791C16.2957 14.6023 17.6926 15.9992 19.4157 15.9992Z" />
    <path d="M15.3379 0C6.86622 0 -0.002217 6.99928 5.36811e-07 15.6307H3.91838C3.91838 9.16211 8.99062 3.91764 15.3379 3.91764C21.6853 3.91764 26.7575 9.16211 26.7575 15.6307H30.6759C30.6774 6.99928 23.8089 0 15.3379 0Z" />
  </>
);

// Aave wordmark. Fills with `currentColor` so it takes the color of its parent
// (e.g. a palette token) — set `color` on the wrapping element to theme it.
export const AaveLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="97"
    height="16"
    viewBox="0 0 97 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {markPaths}
    <path d="M88.2552 12.6135C86.1914 12.6135 84.3575 11.1181 83.8852 9.05362H96.1386C96.1386 9.05362 96.2044 8.30557 96.2044 8.04095C96.2044 3.6591 92.6393 0.0933075 88.2574 0.0933075C83.8756 0.0933075 80.3105 3.65836 80.3105 8.04095C80.3105 12.4235 83.8556 15.9058 88.2574 15.9058C92.6593 15.9058 95.2294 12.663 95.871 10.3154H92.1359C92.1359 10.3154 90.9481 12.6135 88.2552 12.6135ZM88.2574 3.38413C90.2362 3.38413 91.9541 4.69099 92.5425 6.63873H83.9724C84.5586 4.69099 86.2772 3.38413 88.2574 3.38413Z" />
    <path d="M41.4948 15.9058C37.113 15.9058 33.6758 12.3777 33.6758 8.04095C33.6758 3.70419 37.2408 0.0933075 41.6227 0.0933075C46.0045 0.0933075 49.5696 3.79881 49.5696 7.99882C49.5696 9.78837 49.5696 15.5118 49.5696 15.5118H46.4843V13.0045L46.2595 12.9454C45.7163 14.2774 43.7478 15.9058 41.4941 15.9058H41.4948ZM41.6227 3.38413C39.1479 3.38413 37.1337 5.46196 37.1337 8.01656C37.1337 10.5712 39.1472 12.6142 41.6227 12.6142C44.0982 12.6142 46.1117 10.5519 46.1117 8.01656C46.1117 5.48118 44.0982 3.38413 41.6227 3.38413Z" />
    <path d="M58.373 15.9058C53.9911 15.9058 50.554 12.3777 50.554 8.04095C50.554 3.70419 54.119 0.0933075 58.5009 0.0933075C62.8827 0.0933075 66.4478 3.79881 66.4478 7.99882C66.4478 9.78837 66.4478 15.5118 66.4478 15.5118H63.3624V13.0045L63.1377 12.9454C62.5944 14.2774 60.626 15.9058 58.3722 15.9058H58.373ZM58.5009 3.38413C56.0261 3.38413 54.0118 5.46196 54.0118 8.01656C54.0118 10.5712 56.0254 12.6142 58.5009 12.6142C60.9764 12.6142 62.9899 10.5519 62.9899 8.01656C62.9899 5.48118 60.9764 3.38413 58.5009 3.38413Z" />
    <path d="M71.6275 15.5101L65.2949 0.488571H68.7594L73.4007 11.5541L78.0428 0.488571H81.5066L75.1748 15.5101H71.6275Z" />
  </svg>
);

export const AaveLogoMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="31"
    height="16"
    viewBox="0 0 31 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {markPaths}
  </svg>
);
